export default __webpack_public_path__ + "static/media/ibedc.dbde7625.png";